import { useEffect, useState } from "react";
import { DEFAULT_EVENT_IMAGE_URL } from "../../utils/constants";

export const getEventPosterSrc = (image?: string) => {
  return (image && image !== DEFAULT_EVENT_IMAGE_URL
    ? image
    : DEFAULT_EVENT_IMAGE_URL
  ).replace("http:", "https:");
};

export const EventPosterImage = ({
  image,
  alt,
  className = "",
}: {
  image?: string;
  alt: string;
  className?: string;
}) => {
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => {
    setImageFailed(false);
  }, [image]);

  const src = imageFailed ? DEFAULT_EVENT_IMAGE_URL : getEventPosterSrc(image);

  return (
    <img
      className={className}
      alt={alt}
      src={src}
      onError={() => {
        if (src !== DEFAULT_EVENT_IMAGE_URL) {
          setImageFailed(true);
        }
      }}
    />
  );
};
